import React from 'react';

import { createSvgIcon } from '@material-ui/core/utils';

export const AddressingInheritDeny = createSvgIcon(
  <path d="M19 19H5V5H19V19ZM3 5C3 5 3 18 3 19C3 20 4 21 5 21C6 21 18 21 19 21C20 21 21 20 21 19C21 18 21 5.77172 21 5C21 4 20 3 19 3C18 3 10.8388 3 5 3C4 3 3 4 3 5ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z" />,
  'AddressingInheritDeny'
);
